module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338629/particular03-8783d15869ea647f7d88d43a0610cd87.png";